import { Alchemy, Network } from 'alchemy-sdk';

export function getAlchemyNetwork(): Network {
  if (process.env.REACT_APP_EGG_CHAIN === 'eth') {
    return Network.ETH_MAINNET;
  }

  return Network.ETH_GOERLI;
}

export const alchemy = new Alchemy({
  apiKey: process.env.REACT_APP_ALCHEMY_KEY,
  network: getAlchemyNetwork(),
});

/**
 * Collects an async iterable into an array as a promise
 * @param iter
 */
export async function collectAsync<T>(iter: AsyncIterable<T>): Promise<T[]> {
  const out: T[] = [];
  for await (const item of iter) {
    out.push(item);
  }
  return out;
}
